export const radii = {
  sm: "0px",
  md: "0px",
  lg: "0px",
  full: "0px",
};
